'use strict';

const _ = require('underscore');
const Backbone = require('backbone');
const Key = require('common/domain/value/key');
const RelatedKeys = require('common/domain/value/related-keys');

module.exports = Backbone.Model.extend({
    defaults: {
        name: '',
        state: null,
        owner: null,
        assignees: [],
        comment: null,
        comments: null,
        relatedKeys: [],
        updatedAt: null,
        updatedBy: null,
        deleted: false,
        _isActive: false,
    },

    validation: {
        name: {
            required: true
        }
    },

    getName: function() {
        return this.get('name');
    },

    getState: function() {
        return this.get('state');
    },

    getStateChoices: function() {
        return this.get('stateChoices');
    },

    isDone: function() {
        return this.get('state') === 'done';
    },

    isUnfinished: function() {
        return !this.isDone();
    },

    getOwner: function() {
        return this.get('owner');
    },

    setOwner: function(owner) {
        return this.set({owner: owner});
    },

    getAssignees: function() {
        return this.get('assignees');
    },

    getCommentKey: function() {
        const commentKeys = this.get('comments');
        if(!commentKeys || commentKeys.length == 0) {
            return null;
        }

        return new Key(commentKeys[0]);
    },

    setAssignees: function(assignees) {
        return this.set({assignees: assignees});
    },

    getPrimaryRelatedKey: function() {
        return this.getRelatedKeys().primaryKey;
    },

    /**
     * 指定された key が RelatedKeys に含まれる場合と、
     * key が Project の key の場合に true を返す。
     *
     * @param key
     */
    isRelatedTo: function(key) {
        if(key.isEqual(this.key.parent)) {
            return true;
        }

        return this.getRelatedKeys().contains(key);
    },

    getRelatedKeys: function() {
        const keys = _.map(this.get('relatedKeys'), k => new Key(k));
        return new RelatedKeys(keys);
    },

    getRelatedKeysString: function() {
        return _.map(this.getRelatedKeys().keys, k => k.toString());
    },

    getCreatedAt: function() {
        return this.get('createdAt');
    },

    getUpdatedAt: function() {
        return this.get('updatedAt');
    },

    setUpdatedBy: function(updatedBy) {
        return this.set({updatedBy: updatedBy});
    },

    isDeleted: function() {
        return this.get('deleted');
    },

    _setActive: function(active) {
        this.set({_isActive: active});
    },

    activate: function() {
        this._setActive(true);
        this.trigger('active', this);
    },

    deactivate: function() {
        this._setActive(false);
        this.trigger('inactive', this);
    },

    isActive: function() {
        return this.get('_isActive');
    }
});



// WEBPACK FOOTER //
// ./communication/domain/entity/task.js